import { Reveal } from "@/components/Reveal";
import { LeadForm } from "@/components/LeadForm";

export function AuditCTA() {
  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-rw-bg2 border-y border-rw-border relative overflow-hidden" data-testid="audit-cta-section">
      <div className="absolute -bottom-40 right-0 h-96 w-96 rounded-full bg-rw-green/8 blur-[120px]" aria-hidden="true" />
      <div className="container-rw grid gap-12 lg:grid-cols-2 lg:items-center relative">
        <Reveal>
          <p className="eyebrow mb-4">SEO Audit</p>
          <h2 className="font-jakarta font-extrabold tracking-tight text-rw-text text-2xl sm:text-3xl lg:text-4xl leading-[1.12]" data-testid="audit-cta-headline">
            Not sure why your website isn't ranking?
          </h2>
          <p className="mt-5 text-base sm:text-lg text-rw-muted leading-relaxed">
            Get a professional SEO audit covering technical issues, keywords, content, on-page optimization,
            competitors and organic search opportunities.
          </p>
          <ul className="mt-7 space-y-3">
            {["50+ technical checkpoints", "Keyword & competitor gap analysis", "Prioritized 90-day action plan"].map((t) => (
              <li key={t} className="flex items-center gap-3 text-sm text-rw-muted">
                <span className="h-1.5 w-1.5 rounded-full bg-rw-green shrink-0" /> {t}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="rounded-2xl border border-rw-border bg-rw-card p-6 sm:p-8">
            <LeadForm source="audit" testidPrefix="audit-form" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
